export const CUSTOM_LOCAL_STORAGE_EVENT = 'falmyticsVisualizationSaveEventInLocalStorage';
export const TRACKING_EVENTS_LOCAL_STORAGE_KEY = 'TRACKING_VISUALIZATION_EVENTS';
// Our modals have a z-index of 9999, so we are setting this to 99999
export const BACKDROP_Z_INDEX = 99999;
export const LIVE_FEED_BORDER = '1px solid #ddd';
